
import { Component, Mixins } from "vue-property-decorator";
import { ITextPropertyEditable, instanceOfITextPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TextPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITextPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITextPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTextEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITextPropertyEditable(s) && s.text().isEditable(), false);
  }

  get text(): string {
    return this.readPropertyOrDefault(s => s.text().getValue(), "");
  }

  set text(value: string) {
    this.writePropertyWhenValid(s => s.text().setValue(value));
  }
}
